<template>
  <div
    class="button"
    :class="$attrs.class"
    @click.stop.prevent="handleOpenPlayer"
  >
    <iconpark-icon name="bofang" size="30"></iconpark-icon>
    <!-- <iconpark-icon name="play" size="11" class="text-white"></iconpark-icon> -->
  </div>
</template>
<script lang="ts" setup>
import { usePlayView } from '~/features/pageList'
export interface IPlayer {
  url: string
  clickToShowVideo?: boolean
}
const props = withDefaults(defineProps<IPlayer>(), {
  url: '',
  clickToShowVideo: false,
})
defineOptions({
  inheritAttrs: false,
})
const emits = defineEmits(['click'])

const handleOpenPlayer = () => {
  if (props.clickToShowVideo && props.url) {
    usePlayView({ file_url: props?.url })
  }

  emits('click')
}

defineExpose({
  open: handleOpenPlayer,
})
</script>
<style lang="scss" scoped>
.button {
  @apply w-[32px] h-[32px] rounded-[50%] flex justify-center items-center cursor-pointer;
  // background: rgba(0, 0, 0, 0.3);
  // backdrop-filter: blur(3px);
  // box-shadow: 0px 8px 21px -8px rgba(24, 24, 28, 0.11);
  transition: all 0.3s linear;
}

.play-container {
  @apply h-[500px];
  .content {
    @apply w-full h-full overflow-hidden rounded-[6px];

    video {
      @apply w-full h-full relative inset-0 object-cover rounded-[6px];
    }
  }
}
:global(.modal .ant-modal-content) {
  padding: 0 !important;
  background-color: #000 !important;
}
</style>
